import { parsePhoneNumberFromString } from 'libphonenumber-js';

interface PhoneValidationResult {
  formattedNumber: string;
  isValid: boolean;
}

export class PhoneService {
  private static readonly COUNTRY_CODE = '+81';
  private static readonly MAX_LENGTH = 11;

  static normalizePhoneNumber(value: string): string {
    let normalized = value.replace(/[^0-9]/g, '');

    if (normalized.length > 0 && normalized[0] !== '0') {
      normalized = '0' + normalized;
    }

    return normalized.slice(0, this.MAX_LENGTH);
  }

  static formatJapaneseNumber(value: string): PhoneValidationResult {
    if (!value) {
      return { formattedNumber: '', isValid: false };
    }

    const normalized = this.normalizePhoneNumber(value);
    const internationalFormat =
      normalized[0] === '0' ? this.COUNTRY_CODE + normalized.slice(1) : normalized;

    try {
      const phoneNumber = parsePhoneNumberFromString(internationalFormat, 'JP');
      return {
        formattedNumber: phoneNumber?.isValid()
          ? phoneNumber.formatNational().startsWith('0')
            ? phoneNumber.formatNational()
            : '0' + phoneNumber.formatNational()
          : normalized,
        isValid: phoneNumber?.isValid() ?? false
      };
    } catch {
      return { formattedNumber: '0' + normalized, isValid: false };
    }
  }
}
